import { Room, RoomEvent, MatrixEvent } from 'matrix-js-sdk';
import { IMatrixMessage } from '../message/types';

// 使用 message/types 中定义的 IMatrixMessage 类型
export type { IMatrixMessage };

/**
 * 房间成员关系枚举
 * @enum {string}
 */
export enum RoomMembership {
  JOIN = 'join',      // 已加入房间
  INVITE = 'invite',  // 已被邀请
  LEAVE = 'leave',    // 已离开房间
  BAN = 'ban'        // 被封禁
}

export interface IMatrixRoomInfo {
  roomId: string;
  name: string;
  topic?: string;
  avatarUrl?: string;
  unreadCount?: number;
  highlightCount?: number;
}

export interface IBooleanState {
  value: boolean;
}

export interface IMatrixRoomData {
  joinedRooms: IMatrixRoomInfo[];
  // 存储每个房间的消息 ID 数组
  messages: {
    [roomId: string]: string[]; // 存储消息 ID 数组
  };
  // 存储消息详情，key 为消息 ID
  messagesMap: {
    [messageId: string]: IMatrixMessage;
  };
  roomMembers: {
    [roomId: string]: Array<{
      userId: string;
      displayName?: string;
      avatarUrl?: string;
      membership: RoomMembership;
    }>;
  };
  isFetchingMembers: IBooleanState;
}

export interface IEventHandlers {
  [event: string]: ((...args: any[]) => void)[];
}

export interface IRoomManager {
  init(): void;
  getRoomInfo(roomId: string): IMatrixRoomInfo | undefined;
  getRoomById(roomId: string): Promise<Room | null>;
  roomData: IMatrixRoomData;
  loadRoomMessages(roomId: string): Promise<void>;
  sendTextMessage(roomId: string, text: string): Promise<string>;
}

export interface IRoomMember{
  userId: string;
  displayName?: string;
  avatarUrl?: string;
  membership: RoomMembership;
}